import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import List from '@mui/material/List';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PerformanceListItem from '../items/PerformanceListItem';
import PerformanceListItem2 from '../items/PerformanceListItem2';
import IntervalService from './../../services/intervals';
import { checkIfMobile } from '../../services/screen';
import { Views } from './../../enums/enums';
import EditPerformance from '../dialogs/EditPerformance';
import singersStore from './../../stores/singers';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import favoritesStore from './../../stores/favorites';
import settingsStore from '../../stores/settings';
import playerStore from './../../stores/player';
import navigationStore from '../../stores/navigation';

const PerformanceList = React.memo(function PerformanceList(props) {

  const [isEditPerformanceOpen, setIsEditPerformanceOpen] = useState(false);
  const [chosenPerformance, setChosenPerformance] = useState({});

  const editPerformance = performanceStore((state) => state.editPerformance);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const getSingers = singersStore((state) => state.getSingers);
  const singers = singersStore((state) => state.singers);
  const movePerformance = performanceStore((state) => state.movePerformance);
  const setPerformanceToBeChanged = performanceStore((state) => state.setPerformanceToBeChanged);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const setIsSwitching = playerStore((state) => state.setIsSwitching);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setFrom = playerStore((state) => state.setFrom);
  const addPerformanceToPlayList = performanceStore((state) => state.addPerformanceToPlayList);
  const playQueueItems = performanceStore((state) => state.playQueue?.items);
  const playLists = performanceStore((state) => state.playLists);
  const isStopped = playerStore((state) => state.isStopped);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const setMobilePlayerVisible = navigationStore((state) => state.setMobilePlayerVisible);
  const goToView = navigationStore((state) => state.goToView);
  const settingsAutoPlayEnabled = settingsStore((state) => state.settings?.autoplay_enabled);
  const settingsAutoPlaySecs = settingsStore((state) => state.settings?.autoplay_secs);

  useEffect(() => {
    if (!singers) {
      getSingers(sessionToken);
    }
  }, []);

  const handleOpenEditPerformance = useCallback((performance) => {
    setChosenPerformance(performance);
    setIsEditPerformanceOpen(true);
  });

  const handleCloseEditPerformance = () => {
    setIsEditPerformanceOpen(false);
  };

  const handleEdit = (singerProfile, pitch, playList, pos, isManual, playNow) => {
    if (playList) {
      addPerformanceToPlayList(sessionToken, chosenPerformance.track, singerProfile, pitch, playList.id, pos);
    } else {
      if (pos == 0 && playNow) {
        IntervalService.clearAllIntervals();
        setIsAutoPlayOn(false);
        let isMobile = checkIfMobile();
        if (isMobile) {
          goToView(Views.Blank);
          setMobilePlayerVisible(true);
        }
      }
      if (!playNow && ((pos == 0 && chosenPerformance.position != 0) || (pos != 0 && chosenPerformance.position == 0))) {
        setIsPlaying(false);
        setFrom(0);
        setCurrentTime(0);
        if (!isStopped.isStopped) {
          setIsStopped(true);
        }
      }
      console.log("editPerformance", chosenPerformance, pos, playNow);
      editPerformance(sessionToken, chosenPerformance.unique_id, singerProfile, pitch, null, pos, isManual, playNow);
    }
    setIsEditPerformanceOpen(false);
  };

  const handlePerformanceToBeChanged = (performance) => {


    setPerformanceToBeChanged(performance);
  };

  const playQueueItemIds = useMemo(() => {
    console.log("render again");
    return playQueueItems?.map((p) => p.unique_id);
  }, [playQueueItems]);

  const performanceList = useMemo(() => {
    if (playQueueItemIds) {
      console.log("render again");
      return playQueueItemIds.map((performanceId, index) => (

        <PerformanceListItem
          key={`playqueue-${performanceId}`}
          draggableId={`playqueue-${performanceId}`}
          count={playQueueItemIds.length}
          index={index}
          autoPlaySecs={
            settingsAutoPlayEnabled ? settingsAutoPlaySecs : 0
          }
          /*performance={performance}
          performanceToBeChanged={performanceToBeChanged}
                     count={playQueueItems.length}
                    autoPlaySecs={
                      settingsAutoPlayEnabled ? settingsAutoPlaySecs : 0
                    }
                    favorites={favorites}
                    performance={performance}
                    performanceToBeChanged={performanceToBeChanged}*/
          onEditPerformance={handleOpenEditPerformance}
        />
      ));
    }
    return null;
  }, [
    playQueueItemIds
  ]);

  const editPerformanceDialog = () => {
    if (chosenPerformance.track) {
      return <EditPerformance
        open={isEditPerformanceOpen}
        onClose={handleCloseEditPerformance}
        onEdit={handleEdit}
        performance={chosenPerformance}
        onPerformanceToBeChanged={() => {
          handlePerformanceToBeChanged(chosenPerformance);
        }}
        singers={singers}
      />;
    }
  };

  const handleDragEnd = (result) => {
    if (result.destination) {
      let source = result.source.index;
      let dest = result.destination.index;
      if (source != dest) {
        if (source == 0 || dest == 0) {
          IntervalService.clearAllIntervals();
          setIsPlaying(false);
          setFrom(0);
          setIsSwitching(true);
          setCurrentTime(0);
          if (!isStopped.isStopped) {
            setIsStopped(true);
          }
        }
        movePerformance(sessionToken, source, dest);
      }
    }
  };

  return (
    <div style={{ padding: 0 }}>
      {editPerformanceDialog()}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable-playqueue">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <List id="muvika-performance-list-container" className="muvika-performance-list">
                {performanceList}
              </List>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
});

export default PerformanceList;